<template>
    <div v-if="broker != null">

        <div class="text-xl">3rd Party Integrations</div>

        <div class="mt-4 border-t-4 pt-4 border-grey-lighter flex items-center">
            <div class="font-thin text-grey-darker text-lg">Mercury</div>
        </div>

        <div class="my-8">
            <div class="flex flex-wrap">
                <div class="w-full lg:w-1/2 pr-0 lg:pr-3">
                    <InputText
                        label="Username"
                        propertyKey="lodge_user"
                        :value="broker.lodge_user"
                        :updateValue="updateValue" />
                </div>
            </div>

            <div class="flex flex-wrap">
                <div class="w-full lg:w-1/2 pr-0 lg:pr-3 mt-4">
                    <InputPassword
                        label="Password"
                        propertyKey="lodge_pass"
                        :value="broker.lodge_pass"
                        :updateValue="updateValue"></InputPassword>
                </div>
            </div>

            <div class="flex flex-wrap">
                <div class="w-full lg:w-1/2 pr-0 lg:pr-3 mt-4">
                    <InputText
                            label="API key"
                            propertyKey="mercury_api_key"
                            :value="broker.mercury_api_key"
                            :updateValue="updateValue" />
                </div>
            </div>

            <div class="flex flex-wrap">
                <div class="w-full lg:w-1/2 pr-0 lg:pr-3 mt-4">
                    <InputText
                            label="API token"
                            propertyKey="mercury_api_token"
                            :value="broker.mercury_api_token"
                            :updateValue="updateValue" />
                </div>
            </div>

            <div class="mt-6 border-t-4 pt-4 border-grey-lighter flex items-center">
                <div class="font-thin text-grey-darker text-lg">Bankstatements - illion</div>
            </div>

            <div class="flex flex-wrap">
              <div class="w-full lg:w-1/2 pr-0 lg:pr-3 mt-4">
                <InputText
                  label="Refer Code"
                  propertyKey="bankstatements_code"
                  :value="broker.bankstatements_code"
                  :updateValue="updateValue" />
              </div>
            </div>

            <div class="label-line">
              <div class="label-standard">Enable Multi-Bank</div>
            </div>

            <div class="radio-line flex items-center">
              <InputRadio
                name="inputMultiBank"
                id="inputMultiBankYes"
                propertyKey="bankstatements_is_multi_bank"
                objectType="broker"
                :value="true"
                :checked="broker.bankstatements_is_multi_bank == 1"
                :updateValue="updateValue" />

              <label class="text-base ml-2 mr-8" for="inputMultiBankYes">Yes</label>

              <InputRadio
                name="inputMultiBank"
                id="inputMultiBankNo"
                propertyKey="bankstatements_is_multi_bank"
                objectType="broker"
                :value="false"
                :checked="broker.bankstatements_is_multi_bank != 1"
                :updateValue="updateValue" />

              <label class="text-base ml-2 mr-8" for="inputMultiBankNo">No</label>
            </div>



            <div class="mt-6 border-t-4 pt-4 border-grey-lighter flex items-center">
                <div class="font-thin text-grey-darker text-lg">Electronic Signatures (e.g. DocuSign, SignNow)</div>
            </div>

            <div class="flex flex-wrap">
              <div class="w-full lg:w-1/2 pr-0 lg:pr-3 mt-4">
                <InputText
                  label="Link to document for electronic signature"
                  propertyKey="docusign_link"
                  :value="broker.docusign_link"
                  :updateValue="updateValue" />
              </div>
            </div>

        </div>
        <AutoSaveLoader :autoSaving="autoSaving" />
        <br/><br/><br/>
    </div>
</template>
<script>
  import InputText      from '@/shared/components/form/InputText'
  import InputPassword  from '@/shared/components/form/InputPassword'
  import InputRadio     from '@/shared/components/form/InputRadio'
  import AutoSaveLoader from '@/shared/components/loaders/AutoSaveLoader'
  import { EventBus }   from '@/shared/event-bus'

  export default {

    components: {
      InputText,
      InputPassword,
      InputRadio,
      AutoSaveLoader
    },

    data () {
      return {
        loading   : false,
        autoSaving: false,
        broker    : _.cloneDeep(this.$store.state[this.$store.state.view + 'Module'].broker),
      }
    },

    mounted() {
      EventBus.$on('set-autosave', trueOrFalse => {
        this.autoSaving = trueOrFalse
      });
    },

    destroyed() {
      EventBus.$off('set-autosave')
    },

    methods : {
      updateValue(params) {
        this.updateBroker(this.broker, params.key, params.value)
      }
    }
  }
</script>
